module.exports = __webpack_public_path__ + "img/Seismic Resistant Ponmar Township.93f5c406.jpg";